import ApiService from "./ApiService";

export default class VisitPriceService extends ApiService
{
    collection = 'visit_prices'
}